import { render } from "./modal.vue?vue&type=template&id=74fa2dae&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=74fa2dae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kenyo\\Documents\\dev\\passwords\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fa2dae"]])

export default __exports__